import React, { useEffect } from "react";
import {
  ActionIcon,
  Box,
  Menu,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { BiDotsVerticalRounded } from "react-icons/bi";
import swal from "sweetalert";

import RecordNotFound from "../../../RecordNotFound";
import TableLoader from "../../../TableLoader";
import {
  getAllBillingInvoices,
  getAllBillingRecurringInvoices,
  PausedRecurringInvoice,
  removeBillingInvoice,
  resendInvoiceEmail,
} from "../../../../services/billinginvoice";
import EditInvoice from "../EditInvoice";
import CustomInvoicePagination from "../../../Pagination/CustomInovicePagination";
import StatusBtn from "../../../StatusBtn";
import MarkAsPaid from "../MarkAsPaid";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      // backgroundColor: "var(--app-border)",
      color: "var(--app-text) !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableHeader: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
}));

const PreviousRecurringInvoices = ({ data }) => {
  const { classes, cx } = useStyles();
  const { profile } = useSelector((state) => state?.profile);
  const [scrolled, setScrolled] = useState(false);
  const { allbillingRecurringinvoices, loading, CashandChequeInvoice } =
    useSelector((state) => state.billinginvoiceReducer);
  const [editinvoice, setEditinvoice] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [markasPaidOpen, setMarkAsPaidOpen] = useState(false);
  const [pausedrecurring, setPausedRecurring] = useState(false);
  const [paymentdetials, setPaymentdetials] = useState(null);

  // console.log("allbillingRecurringinvoices", allbillingRecurringinvoices);
  let currentId = 1;
  const onEdit = (data) => {
    setInvoice(data);
    setEditinvoice(true);
  };

  const remove = async (id) => {
    let payload = {
      id,
    };
    console.log('payload',payload);
    

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeBillingInvoice(payload);
  };

  // const marksaspaid = async (data) => {
  //   let payload = {
  //     admin: profile.user.id,
  //     invoiceid: data.id,
  //   };

  //   console.log("payload", payload);

  //   const res = await UpdateBillingInvoicesStatus(payload);

  //   if (res.status === 200) {
  //     let payload={
  //       page:1
  //     }
  //     getAllBillingInvoices(payload);
  //     swal({
  //       title: `Invoice updated successfully`,
  //       text: "Invoice updated successfully",
  //       dangerMode: false,
  //       icon: "success",
  //     });
  //   }

  //   // setInvoice(data);
  //   // setEditinvoice(true);
  // };

  const marksaspaid = async (item) => {
    console.log("item", item);
    setMarkAsPaidOpen(true);
    setPaymentdetials(item);
  };

  const ResendInvoice = async (data) => {
    let payload = {
      admin: profile.user.id,
      invoiceid: data.id,
    };

    console.log("payload", payload);

    const res = await resendInvoiceEmail(payload);

    if (res.status === 200) {
      // getAllBillingInvoices();
      let payload = {
        page: 1,
      };
      getAllBillingInvoices(payload);
      swal({
        title: `Invoice email resend successfully`,
        text: "Invoice email resend successfully",
        dangerMode: false,
        icon: "success",
      });
    }
  };

  // const PausedInvoice = async (data) => {
  //   let payload = {
  //     invoiceId: data.id,
  //     pausedStatus: pausedrecurring,
  //   };

  //   // console.log("payload", payload);

  //   const res = await PausedRecurringInvoice(payload);

  //   let status=pausedrecurring === true ? 'Paused':"Resume"

  //   if (res.status === 200) {
  //     // getAllBillingInvoices();
  //     let payload = {
  //       page: 1,
  //     };
  //     getAllBillingInvoices(payload);
  //     swal({
  //       title: `Invoice  ${status} successfully`,
  //       text: `Invoice ${status} successfully`,
  //       dangerMode: false,
  //     });
  //   }
  // };

const PausedInvoice = async (data, newPausedStatus) => {
  let payload = {
    invoiceId: data.id,
    pausedStatus: newPausedStatus,
  };

  const res = await PausedRecurringInvoice(payload);
  let status = newPausedStatus ? 'Paused' : 'Resumed';

  if (res.status === 200) {
    getAllBillingInvoices({ page: 1 });
    swal({
      title: `Invoice ${status} successfully`,
      text: `Invoice ${status} successfully`,
      dangerMode: false,
    });
  }
};


  function generateSequentialId() {
    const id = String(currentId).padStart(6, "0");
    currentId++;
    return id;
  }
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getAllBillingRecurringInvoices({ page: currentPage });
  }, [currentPage]);

  return (
    <>
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ marginTop: "30px", minHeight: "300px" }}
      >
        <Table
          // withBorder
          highlightOnHover
          enableStickyHeader
          sx={{
            fontFamily: "Inter",
            borderRadius: "15px",
            border: "1px solid var(--app-border)",
          }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Status
              </th>

              <th
                style={{ minWidth: "140px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Customer ID
              </th>
              <th
                style={{ minWidth: "200px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Invoice Title
              </th>

              <th style={{ minWidth: "200px" }} className={classes.tableHeader}>
                Invoice Created Date
              </th>

              <th style={{ minWidth: "200px" }} className={classes.tableHeader}>
                Next Invoice Date
              </th>

              
              <th style={{ minWidth: "200px" }} className={classes.tableHeader}>
                Recurring Paused
              </th>

              <th
                style={{ minWidth: "200px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Customer Name
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer Email
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Payment Amount
              </th>

              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={1000}>
                  <TableLoader />
                </td>
              </tr>
            ) : allbillingRecurringinvoices &&
              allbillingRecurringinvoices?.billinginvoice?.length > 0 ? (
              allbillingRecurringinvoices?.billinginvoice?.map((row, index) => (
                <tr key={index}>
                  <td>
                    <StatusBtn status={row.status} />
                  </td>
                  <td>{row?.consumer?.consumerId}</td>
                  <td>{row.invoiceTitle || "-"}</td>
                  <td>
                    {row?.invoiceCreatedDate
                      ? new Date(row?.invoiceCreatedDate).toLocaleDateString(
                          "en-US"
                        )
                      : "date Not Available"}
                  </td>
                  <td>
                    {row?.recurringNextDate
                      ? new Date(row?.recurringNextDate).toLocaleDateString(
                          "en-US"
                        )
                      : "date Not Available"}
                  </td>
      <td>{row?.recurringPaused ?'Yes':'No'}</td>
                  <td>{row?.consumer?.name}</td>
                  <td>{row?.consumer?.email}</td>
                  <td>${row.totalAmount}</td>

                  <td>
                    <Menu shadow="md" position="left" zIndex={"1000"}>
                      <Menu.Target>
                        <ActionIcon className={classes.marginTop}>
                          <BiDotsVerticalRounded
                            id="vertical-dots"
                            size={20}
                            color="var(--app-text)"
                          />
                        </ActionIcon>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          id="open-link"
                          // icon={<IconEye size={14} />}
                          onClick={() => {
                            onEdit(row);
                            setIsPreview(true);
                          }}
                        >
                          View
                        </Menu.Item>
                        <Menu.Item
                          id="open-link"
                          // icon={<IconEye size={14} />}
                          // onClick={() => {
                          //   setPausedRecurring(!row?.recurringPaused);
                          //   PausedInvoice(row);
                          // }}

                          onClick={() => {
  const newPausedStatus = !row?.recurringPaused;
  PausedInvoice(row, newPausedStatus);
}}

                        >

                     { row?.recurringPaused === true ? 'Resume' : 'Pause'}
                        
                        </Menu.Item>
                        {/* <Menu.Item icon={<IconDownload size={14} />}>Download</Menu.Item> */}

                        {/* <Menu.Item icon={<IconEdit size={14} />} onClick={open}> */}

                        {CashandChequeInvoice?.cashChequeInvoices?.find(
                          (item) =>
                            item?.invoiceId === row?.id &&
                            row?.status !== "Paid"
                        ) && (
                          <Menu.Item
                            onClick={() =>
                              marksaspaid(
                                CashandChequeInvoice?.cashChequeInvoices?.find(
                                  (item) =>
                                    item.invoiceId === row.id &&
                                    row?.status !== "Paid"
                                )
                              )
                            }
                          >
                            Mark as Paid
                          </Menu.Item>
                        )}

                        {row?.status !== "Paid" ? (
                          <>
                            <Menu.Item
                              // icon={<IconEdit size={14} />}
                              // onClick={() => onEdit(row)}
                              //  onClick={() => onEdit(row)}
                              onClick={() => ResendInvoice(row)}
                            >
                              Resend
                            </Menu.Item>
                          </>
                        ) : null}

                        {row?.status !== "Paid" ? (
                          <>
                            <Menu.Item
                              id="open-link"
                              // icon={<IconEye size={14} />}
                              onClick={() => {
                                onEdit(row);
                                setIsPreview(false);
                              }}
                            >
                              Edit
                            </Menu.Item>

                            <Menu.Item onClick={() => remove(row?.id)}>
                              Delete
                            </Menu.Item>
                          </>
                        ) : null}
                      </Menu.Dropdown>
                    </Menu>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={1000}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      height: "75vh",
                      gap: "8rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text className="notFoundText">
                      You don&apos;t have any record, click on “Create Invoices”
                    </Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </ScrollArea>
      <CustomInvoicePagination
        data={allbillingRecurringinvoices?.count}
        itemsPerPage={10}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />

      <EditInvoice
        editinvoice={editinvoice}
        setEditinvoice={setEditinvoice}
        invoice={invoice}
        setInvoice={setInvoice}
        isPreview={isPreview}
        setIsPreview={setIsPreview}
      />

      <MarkAsPaid
        markasPaidOpen={markasPaidOpen}
        setMarkAsPaidOpen={setMarkAsPaidOpen}
        paymentdetials={paymentdetials}
      />
    </>
  );
};

export default PreviousRecurringInvoices;
